export default __webpack_public_path__ + "static/media/碳盤查2.2aa5d79b.png";